module.exports = __webpack_public_path__ + "static/media/title_r.040f669d.svg";